<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :selectedIndex="selectedIndex"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Features" />
    </template>
    <DxToolbar class="view-toolbar">
      <DxItem
        :options="toolbar.edit"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode == 'review'"
      />
      <DxItem
        :options="toolbar.save"
        location="after"
        locate-in-menu="auto"
        widget="dxButton"
        v-if="baseView.mode != 'review'"
      />
    </DxToolbar>

    <!-- form -->
    <div class="view-card responsive-paddings" id="userPanel">
      <form>
        <DxForm
          :form-data.sync="model"
          :read-only="false"
          :show-colon-after-label="false"
          :show-required-mark="false"
          :show-validation-summary="false"
          :validation-group="formsConfig.validationGroup"
          :col-count-by-screen="colCountByScreen"
          label-location="left"
          :customizeItem="customizeItem"
          :items.sync="items"
          ref="userForm"
          cssClass="cssClass"
        ></DxForm>
      </form>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../../v1/_mixins/base.view";
import { DxForm } from "devextreme-vue/form";
import { FeatureService } from "../../../_services/api/settings/graycorp/feature.service";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {
    DxForm,
  },
  watch: {
    // $route: {
    //   immediate: true,
    //   handler: "requestFeatureManagementDetails",
    // },
  },
  data() {
    return {
      toolbar: {
        edit: {
          icon: "edit",
          onClick: () => {
            // this.editEnable = true;
            // let form = this.$refs["userForm"].instance;
            // form.repaint();
            this.$router.push({
              path: `/feature/edit`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: () => {
            this.$logger.trackEventButtonClickSave();
            this.showLoading(true);

            var payload = {
              ApplicationFeatureManagementFeatures: {
                ApplicationFeatureManagementFeature: [],
              },
            };

            for (let index = 0; index < this.payLoadHelper.length; index++) {
              if (
                this.model.features[
                  this.payLoadHelper[index].ApplicationFeatureCode
                ] == true
              ) {
                this.payLoadHelper[index].Value = "Y";
                payload.ApplicationFeatureManagementFeatures.ApplicationFeatureManagementFeature.push(
                  this.payLoadHelper[index]
                );
              }
            }
            this.saveFeatureDetails(payload);
          },
        },
      },
      position: { of: "#userPanel" },
      loadingVisible: true,
      showIndicator: true,
      shading: true,
      showPane: true,
      hideOnOutsideClick: false,
      model: {
        features: {},
      },
      colCountByScreen: {
        xs: 1,
        sm: 1,
        md: 1,
        lg: 1,
      },

      items: [
        {
          itemType: "group",
          caption: "",
          colCountByScreen: {
            xs: 1,
            sm: 1,
            md: 2,
            lg: 2,
          },
          items: [],
        },
      ],
      payLoadHelper: [],
    };
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: "/settings/user",
      });
    },
    requestFeatureManagementDetails() {
      this.showLoading(true);
      this.getFeatureManagement().then((response) => {
        this.generateFormData(
          response.data.ApplicationFeatureManagementFeatures
            .ApplicationFeatureManagementFeature
        );
      });
    },
    async getFeatureManagement() {
      return await FeatureService.getFeatureManagementData({
        url: `api/ApplicationFeatureManagement`,
        expand:
          "ApplicationFeatureManagementFeatures($expand=ApplicationFeatureManagementFeature($expand=ApplicationFeatureManagementFeatures($expand=ApplicationFeatureManagementFeature($expand=ApplicationFeatureManagementFeatures($expand=ApplicationFeatureManagementFeature)))))",
      });
    },
    generateFormData(data) {
      let form = this.$refs["userForm"].instance;
      this.items[0].items = [];
      this.payLoadHelper = [];
      this.model.features = {};

      var workCenter = data.filter((x) => x.Type == "Work Centre");
      for (let x = 0; x < workCenter.length; x++) {
        var workCentreType = {};
        workCentreType.itemType = "group";
        workCentreType.caption = workCenter[x].DisplayName;
        workCentreType.items = [];
        var moduleCenter = workCenter[
          x
        ].ApplicationFeatureManagementFeatures.ApplicationFeatureManagementFeature.filter(
          (x) => x.Type == "Module"
        );
        for (let y = 0; y < moduleCenter.length; y++) {
          var moduleType = {};
          moduleType.itemType = "group";
          moduleType.caption = moduleCenter[y].DisplayName;
          moduleType.items = [];
          var screenCenter = moduleCenter[
            y
          ].ApplicationFeatureManagementFeatures.ApplicationFeatureManagementFeature.filter(
            (x) =>
              x.Type == "Advanced Master Screen" ||
              x.Type == "Screen" ||
              x.Type == "Grid Report" ||
              x.Type == "Formatted Report" ||
              x.Type == "Transaction Report" ||
              x.Type == "Grid Report" ||
              x.Type == "Screen Setting" ||
              x.Type == "Settings Screen"
          );
          for (let z = 0; z < screenCenter.length; z++) {
            var screenType = {};
            screenType.label = {
              text: screenCenter[z].DisplayName,
            };
            screenType.editorType = "dxSwitch";
            if (screenCenter[z].Value == "Y") {
              screenType.editorOptions = {
                value: true,
              };
            } else {
              screenType.editorOptions = {
                value: false,
              };
            }

            screenType.dataField =
              "features." + screenCenter[z].ApplicationFeatureCode;
            this.payLoadHelper.push(screenCenter[z]);
            moduleType.items.push(screenType);
          }
          workCentreType.items.push(moduleType);
        }
        this.items[0].items.push(workCentreType);
      }

      form.repaint();
      this.showLoading(false);
    },
    async saveFeatureDetails(payload) {
      await FeatureService.saveFeatureManagement(payload)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          // this.loadingVisible = false;
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveFeatureDetails", response);
          this.$notify("Features saved successfully", "success");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/feature`,
          });

          this.requestFeatureManagementDetails();
        })
        .catch((error) => {
          this.displayServerError(error, "Features saved Failed");
        });
    },
  },
  created() {
    this.toolbar.edit.visible = this.formsConfig.editableOption;
    this.requestFeatureManagementDetails();
  },
};
</script>
